var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"animated fadeIn"},[(_vm.msg)?_c('h1',[_vm._v(_vm._s(_vm.msg))]):_vm._e(),_c('div',{staticClass:"btn-primary",on:{"click":function($event){return _vm.$emit('phone')}}},[_vm._v("验证手机号")])])}
var staticRenderFns = []

export { render, staticRenderFns }